"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequiredInputs = exports.MXProvincesDisplay = exports.MXProvices = exports.CAProvincesDisplay = exports.CAProvinces = exports.USStatesDisplay = exports.USStates = exports.CountryDisplay = exports.Countries = exports.Language = void 0;
var Language;

(function (Language) {
  Language["en"] = "en";
  Language["fr"] = "fr";
  Language["es"] = "es";
})(Language || (exports.Language = Language = {}));

var Countries;

(function (Countries) {
  Countries["us"] = "us";
  Countries["ca"] = "cs";
  Countries["mx"] = "mx";
})(Countries || (exports.Countries = Countries = {}));

var CountryDisplay;

(function (CountryDisplay) {
  CountryDisplay["us"] = "United States";
  CountryDisplay["ca"] = "Canada";
  CountryDisplay["mx"] = "Mexico";
})(CountryDisplay || (exports.CountryDisplay = CountryDisplay = {}));

var USStates;

(function (USStates) {
  USStates["AL"] = "AL";
  USStates["AK"] = "AK";
  USStates["AZ"] = "AZ";
  USStates["AR"] = "AR";
  USStates["CA"] = "CA";
  USStates["CO"] = "CO";
  USStates["CT"] = "CT";
  USStates["DE"] = "DE";
  USStates["FL"] = "FL";
  USStates["GA"] = "GA";
  USStates["HI"] = "HI";
  USStates["ID"] = "ID";
  USStates["IL"] = "IL";
  USStates["IN"] = "IN";
  USStates["IA"] = "IA";
  USStates["KS"] = "KS";
  USStates["KY"] = "KY";
  USStates["LA"] = "LA";
  USStates["ME"] = "ME";
  USStates["MD"] = "MD";
  USStates["MA"] = "MA";
  USStates["MI"] = "MI";
  USStates["MN"] = "MN";
  USStates["MS"] = "MS";
  USStates["MO"] = "MO";
  USStates["MT"] = "MT";
  USStates["NE"] = "NE";
  USStates["NV"] = "NV";
  USStates["NH"] = "NH";
  USStates["NJ"] = "NJ";
  USStates["NM"] = "NM";
  USStates["NY"] = "NY";
  USStates["NC"] = "NC";
  USStates["ND"] = "ND";
  USStates["OH"] = "OH";
  USStates["OK"] = "OK";
  USStates["OR"] = "OR";
  USStates["PA"] = "PA";
  USStates["RI"] = "RI";
  USStates["SC"] = "SC";
  USStates["SD"] = "SD";
  USStates["TN"] = "TN";
  USStates["TX"] = "TX";
  USStates["UT"] = "UT";
  USStates["VT"] = "VT";
  USStates["VA"] = "VA";
  USStates["WA"] = "WA";
  USStates["WV"] = "WV";
  USStates["WI"] = "WI";
  USStates["WY"] = "WY";
})(USStates || (exports.USStates = USStates = {}));

var USStatesDisplay;

(function (USStatesDisplay) {
  USStatesDisplay["AL"] = "Alabama";
  USStatesDisplay["AK"] = "Alaska";
  USStatesDisplay["AZ"] = "Arizona";
  USStatesDisplay["AR"] = "Arkansas";
  USStatesDisplay["CA"] = "California";
  USStatesDisplay["CO"] = "Colorado";
  USStatesDisplay["CT"] = "Connecticut";
  USStatesDisplay["DE"] = "Delaware";
  USStatesDisplay["FL"] = "Florida";
  USStatesDisplay["GA"] = "Georgia";
  USStatesDisplay["HI"] = "Hawaii";
  USStatesDisplay["ID"] = "Idaho";
  USStatesDisplay["IL"] = "Illinois";
  USStatesDisplay["IN"] = "Indiana";
  USStatesDisplay["IA"] = "Iowa";
  USStatesDisplay["KS"] = "Kansas";
  USStatesDisplay["KY"] = "Kentucky";
  USStatesDisplay["LA"] = "Louisiana";
  USStatesDisplay["ME"] = "Maine";
  USStatesDisplay["MD"] = "Maryland";
  USStatesDisplay["MA"] = "Massachusetts";
  USStatesDisplay["MI"] = "Michigan";
  USStatesDisplay["MN"] = "Minnesota";
  USStatesDisplay["MS"] = "Mississippi";
  USStatesDisplay["MO"] = "Missouri";
  USStatesDisplay["MT"] = "Montana";
  USStatesDisplay["NE"] = "Nebraska";
  USStatesDisplay["NV"] = "Nevada";
  USStatesDisplay["NH"] = "New Hampshire";
  USStatesDisplay["NJ"] = "New Jersey";
  USStatesDisplay["NM"] = "New Mexico";
  USStatesDisplay["NY"] = "New York";
  USStatesDisplay["NC"] = "North Carolina";
  USStatesDisplay["ND"] = "North Dakota";
  USStatesDisplay["OH"] = "Ohio";
  USStatesDisplay["OK"] = "Oklahoma";
  USStatesDisplay["OR"] = "Oregon";
  USStatesDisplay["PA"] = "Pennsylvania";
  USStatesDisplay["RI"] = "Rhode Island";
  USStatesDisplay["SC"] = "South Carolina";
  USStatesDisplay["SD"] = "South Dakota";
  USStatesDisplay["TN"] = "Tennessee";
  USStatesDisplay["TX"] = "Texas";
  USStatesDisplay["UT"] = "Utah";
  USStatesDisplay["VT"] = "Vermont";
  USStatesDisplay["VA"] = "Virginia";
  USStatesDisplay["WA"] = "Washington";
  USStatesDisplay["WV"] = "West Virginia";
  USStatesDisplay["WI"] = "Wisconsin";
  USStatesDisplay["WY"] = "Wyoming";
})(USStatesDisplay || (exports.USStatesDisplay = USStatesDisplay = {}));

var CAProvinces;

(function (CAProvinces) {
  CAProvinces["AB"] = "AB";
  CAProvinces["BC"] = "BC";
  CAProvinces["MB"] = "MB";
  CAProvinces["NB"] = "NB";
  CAProvinces["NL"] = "NL";
  CAProvinces["NT"] = "NT";
  CAProvinces["NS"] = "NS";
  CAProvinces["NU"] = "NU";
  CAProvinces["ON"] = "ON";
  CAProvinces["PE"] = "PE";
  CAProvinces["QC"] = "QC";
  CAProvinces["SK"] = "SK";
  CAProvinces["YT"] = "YT";
})(CAProvinces || (exports.CAProvinces = CAProvinces = {}));

var CAProvincesDisplay;

(function (CAProvincesDisplay) {
  CAProvincesDisplay["AB"] = "Alberta";
  CAProvincesDisplay["BC"] = "British Columbia";
  CAProvincesDisplay["MB"] = "Manitoba";
  CAProvincesDisplay["NB"] = "New Brunswick";
  CAProvincesDisplay["NL"] = "Newfoundland & Labr.";
  CAProvincesDisplay["NT"] = "Northwest Terr.";
  CAProvincesDisplay["NS"] = "Nova Scotia";
  CAProvincesDisplay["NU"] = "Nunavut";
  CAProvincesDisplay["ON"] = "Ontario";
  CAProvincesDisplay["PE"] = "Prince Edward Island";
  CAProvincesDisplay["QC"] = "Quebec";
  CAProvincesDisplay["SK"] = "Saskatchewan";
  CAProvincesDisplay["YT"] = "Yukon Territory";
})(CAProvincesDisplay || (exports.CAProvincesDisplay = CAProvincesDisplay = {}));

var MXProvices;

(function (MXProvices) {
  MXProvices["AGS"] = "AGS";
  MXProvices["BCS"] = "BCS";
  MXProvices["CMP"] = "CMP";
  MXProvices["CHS"] = "CHS";
  MXProvices["CHI"] = "CHI";
  MXProvices["COA"] = "COA";
  MXProvices["COL"] = "COL";
  MXProvices["DF"] = "DF";
  MXProvices["DGO"] = "DGO";
  MXProvices["GTO"] = "GTO";
  MXProvices["GRO"] = "GRO";
  MXProvices["HGO"] = "HGO";
  MXProvices["JAL"] = "JAL";
  MXProvices["MCH"] = "MCH";
  MXProvices["MOR"] = "MOR";
  MXProvices["NAY"] = "NAY";
  MXProvices["NL"] = "NL";
  MXProvices["OAX"] = "OAX";
  MXProvices["PUE"] = "PUE";
  MXProvices["QRO"] = "QRO";
  MXProvices["QR"] = "QR";
  MXProvices["SLP"] = "SLP";
  MXProvices["SIN"] = "SIN";
  MXProvices["SON"] = "SON";
  MXProvices["TAB"] = "TAB";
  MXProvices["TMS"] = "TMS";
  MXProvices["TLX"] = "TLX";
  MXProvices["VER"] = "VER";
  MXProvices["YUC"] = "YUC";
  MXProvices["ZAC"] = "ZAC";
})(MXProvices || (exports.MXProvices = MXProvices = {}));

var MXProvincesDisplay;

(function (MXProvincesDisplay) {
  MXProvincesDisplay["AGS"] = "Aguascalientes";
  MXProvincesDisplay["BCS"] = "Baja California S";
  MXProvincesDisplay["CMP"] = "Campeche";
  MXProvincesDisplay["CHS"] = "Chiapas";
  MXProvincesDisplay["CHI"] = "Chihuahua";
  MXProvincesDisplay["COA"] = "Coahuila";
  MXProvincesDisplay["COL"] = "Colima";
  MXProvincesDisplay["DF"] = "Distrito Federal";
  MXProvincesDisplay["DGO"] = "Durango";
  MXProvincesDisplay["GTO"] = "Guanajuato";
  MXProvincesDisplay["GRO"] = "Guerrero";
  MXProvincesDisplay["HGO"] = "Hidalgo";
  MXProvincesDisplay["JAL"] = "Jalisco";
  MXProvincesDisplay["MCH"] = "Michoac\xE1n";
  MXProvincesDisplay["MOR"] = "Morelos";
  MXProvincesDisplay["NAY"] = "Nayarit";
  MXProvincesDisplay["NL"] = "Nuevo L\xE9on";
  MXProvincesDisplay["OAX"] = "Oaxaca";
  MXProvincesDisplay["PUE"] = "Puebla";
  MXProvincesDisplay["QRO"] = "Quer\xE9taro";
  MXProvincesDisplay["QR"] = "Quintana Roo";
  MXProvincesDisplay["SLP"] = "San Luis Potos\xED";
  MXProvincesDisplay["SIN"] = "Sinaloa";
  MXProvincesDisplay["SON"] = "Sonora";
  MXProvincesDisplay["TAB"] = "Tabasco";
  MXProvincesDisplay["TMS"] = "Tamaulipas";
  MXProvincesDisplay["TLX"] = "Tlaxcala";
  MXProvincesDisplay["VER"] = "Veracruz";
  MXProvincesDisplay["YUC"] = "Yucat\xE1n";
  MXProvincesDisplay["ZAC"] = "Zacatecas";
})(MXProvincesDisplay || (exports.MXProvincesDisplay = MXProvincesDisplay = {}));

var RequiredInputs;

(function (RequiredInputs) {
  RequiredInputs["streetAddressOne"] = "streetAddressOne";
  RequiredInputs["city"] = "city";
  RequiredInputs["stateProvince"] = "stateProvince";
  RequiredInputs["zipPostal"] = "zipPostal";
  RequiredInputs["country"] = "country";
})(RequiredInputs || (exports.RequiredInputs = RequiredInputs = {}));